import { Thunk } from '../../../types';
import { State } from './types';

import actions from './authFeatureFlagsActions';

import { getFeatureFlags } from '../../../services/featureFlags';

const authFeatureFlagRequestStart = (): Thunk => (dispatch) =>
    dispatch({
        type: actions.AUTH_FEATURE_FLAGS__REQUEST_START,
        payload: {
            requestState: 'pending',
            errorMessage: '',
        },
    });

const authFeatureFlagRequestSuccess = (flags: State['flags']): Thunk => (
    dispatch,
) => {
    dispatch({
        type: actions.AUTH_FEATURE_FLAGS__REQUEST_SUCCESS,
        payload: {
            requestState: 'success',
            flags,
        },
    });
};

const authFeatureFlagRequestReject = (
    errorMessage: State['errorMessage'],
): Thunk => (dispatch) =>
    dispatch({
        type: actions.AUTH_FEATURE_FLAGS__REQUEST_REJECT,
        payload: {
            requestState: 'error',
            errorMessage,
        },
    });

const setAuthFeatureFlags = (): Thunk => async (dispatch) => {
    try {
        dispatch(authFeatureFlagRequestStart());

        const flags = await getFeatureFlags();
        dispatch(authFeatureFlagRequestSuccess(flags));
    } catch (error) {
        dispatch(authFeatureFlagRequestReject(error.message));
    }
};

export default {
    authFeatureFlagRequestStart,
    authFeatureFlagRequestSuccess,
    authFeatureFlagRequestReject,
    setAuthFeatureFlags,
};
